import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import { connect } from 'react-redux';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Link from '@cotyorg/ccx-atoms/Link';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import { CardsCarousel } from '@cotyorg/ccx-organism-carousel';
import { trackCarouselClickEvent } from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/carousel';
import { HeroFullBlockQuarter } from '@cotyorg/ccx-organism-hero';
import StandardLayout from '../../templates/StandardLayout';

const HowToComponent = ({ carousels }) => (
  <StandardLayout>
    <div className="hero-full-block--main how-to-section-header">
      <HeroFullBlockQuarter heroStoreDataKey="hero" isUnderlined={false} />
    </div>

    <OptionalSection
      renderCondition={R.has('Carousel1', carousels)}
      section={() => (
        <div className="how-to-section grid-container">
          <div className="grid-x">
            <div className="cell xsmall-14 xsmall-offset-1 large-12 large-offset-2">
              <Heading level={4} extraClass="how-to-section__heading">
                {R.path(['Carousel1', 'title'], carousels)}
              </Heading>

              <CardsCarousel
                carousel={{
                  carouselsStoreDataKey: 'Carousel1',
                  headingLevel: 4,
                  leftChevronIconSrc: '/ccx-files/assets/chevron-left.svg',
                  rightChevronIconSrc: '/ccx-files/assets/chevron-right.svg',
                  onIndexChange: ({ type, index, isForward }) =>
                    trackCarouselClickEvent({
                      page: 'howTo',
                      carousel: 'Carousel1',
                      type,
                      index,
                      isForward,
                    }),
                }}
                cards={{
                  cardsStoreDataKey: 'Carousel1',
                  headingLevel: 5,
                  isTitleUnderlined: false,
                  cover: true,
                  zoomOnHover: true,
                  hideDescription: true,
                }}
                cardsPerPageMap={{
                  xsmall: 1,
                  small: 2,
                  medium: 3,
                  large: 3,
                  xlarge: 3,
                }}
              />

              {R.path(['Carousel1', 'cta', 'title'], carousels) && (
                <Link
                  title={R.path(['Carousel1', 'cta', 'title'], carousels)}
                  link={R.path(['Carousel1', 'cta', 'href'], carousels)}
                  extraClass="button button--large button--primary how-to-section__cta medium-one-third-width-cell"
                >
                  {R.path(['Carousel1', 'cta', 'title'], carousels)}
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    />

    <OptionalSection
      renderCondition={R.has('Carousel2', carousels)}
      section={() => (
        <div className="how-to-section grid-container">
          <div className="grid-x">
            <div className="cell xsmall-14 xsmall-offset-1 large-12 large-offset-2">
              <Heading level={4} extraClass="how-to-section__heading">
                {R.path(['Carousel2', 'title'], carousels)}
              </Heading>

              <CardsCarousel
                carousel={{
                  carouselsStoreDataKey: 'Carousel2',
                  headingLevel: 4,
                  leftChevronIconSrc: '/ccx-files/assets/chevron-left.svg',
                  rightChevronIconSrc: '/ccx-files/assets/chevron-right.svg',
                  onIndexChange: ({ type, index, isForward }) =>
                    trackCarouselClickEvent({
                      page: 'howTo',
                      carousel: 'Carousel2',
                      type,
                      index,
                      isForward,
                    }),
                }}
                cards={{
                  cardsStoreDataKey: 'Carousel2',
                  headingLevel: 5,
                  isTitleUnderlined: false,
                  cover: true,
                  zoomOnHover: true,
                  hideDescription: true,
                }}
                cardsPerPageMap={{
                  xsmall: 1,
                  small: 2,
                  medium: 3,
                  large: 3,
                  xlarge: 3,
                }}
              />

              {R.path(['Carousel2', 'cta', 'title'], carousels) && (
                <Link
                  title={R.path(['Carousel2', 'cta', 'title'], carousels)}
                  link={R.path(['Carousel2', 'cta', 'href'], carousels)}
                  extraClass="button button--large button--primary how-to-section__cta medium-one-third-width-cell"
                >
                  {R.path(['Carousel2', 'cta', 'title'], carousels)}
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    />

    <OptionalSection
      renderCondition={R.has('Carousel3', carousels)}
      section={() => (
        <div className="how-to-section grid-container">
          <div className="grid-x">
            <div className="cell xsmall-14 xsmall-offset-1 large-12 large-offset-2">
              <Heading level={4} extraClass="how-to-section__heading">
                {R.path(['Carousel3', 'title'], carousels)}
              </Heading>

              <CardsCarousel
                carousel={{
                  carouselsStoreDataKey: 'Carousel3',
                  headingLevel: 4,
                  leftChevronIconSrc: '/ccx-files/assets/chevron-left.svg',
                  rightChevronIconSrc: '/ccx-files/assets/chevron-right.svg',
                  onIndexChange: ({ type, index, isForward }) =>
                    trackCarouselClickEvent({
                      page: 'howTo',
                      carousel: 'Carousel3',
                      type,
                      index,
                      isForward,
                    }),
                }}
                cards={{
                  cardsStoreDataKey: 'Carousel3',
                  headingLevel: 5,
                  isTitleUnderlined: false,
                  cover: true,
                  zoomOnHover: true,
                  hideDescription: true,
                }}
                cardsPerPageMap={{
                  xsmall: 1,
                  small: 2,
                  medium: 3,
                  large: 3,
                  xlarge: 3,
                }}
              />
              {R.path(['Carousel3', 'cta', 'title'], carousels) && (
                <Link
                  title={R.path(['Carousel3', 'cta', 'title'], carousels)}
                  link={R.path(['Carousel3', 'cta', 'href'], carousels)}
                  extraClass="button button--large button--primary how-to-section__cta medium-one-third-width-cell"
                >
                  {R.path(['Carousel3', 'cta', 'title'], carousels)}
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    />

    <OptionalSection
      renderCondition={R.has('Carousel4', carousels)}
      section={() => (
        <div className="how-to-section grid-container">
          <div className="grid-x">
            <div className="cell xsmall-14 xsmall-offset-1 large-12 large-offset-2">
              <Heading level={4} extraClass="how-to-section__heading">
                {R.path(['Carousel4', 'title'], carousels)}
              </Heading>

              <CardsCarousel
                carousel={{
                  carouselsStoreDataKey: 'Carousel4',
                  headingLevel: 4,
                  leftChevronIconSrc: '/ccx-files/assets/chevron-left.svg',
                  rightChevronIconSrc: '/ccx-files/assets/chevron-right.svg',
                  onIndexChange: ({ type, index, isForward }) =>
                    trackCarouselClickEvent({
                      page: 'howTo',
                      carousel: 'Carousel4',
                      type,
                      index,
                      isForward,
                    }),
                }}
                cards={{
                  cardsStoreDataKey: 'Carousel4',
                  headingLevel: 5,
                  isTitleUnderlined: false,
                  cover: true,
                  zoomOnHover: true,
                  hideDescription: true,
                }}
                cardsPerPageMap={{
                  xsmall: 1,
                  small: 2,
                  medium: 3,
                  large: 3,
                  xlarge: 3,
                }}
              />
              {R.path(['Carousel4', 'cta', 'title'], carousels) && (
                <Link
                  title={R.path(['Carousel4', 'cta', 'title'], carousels)}
                  link={R.path(['Carousel4', 'cta', 'href'], carousels)}
                  extraClass="button button--large button--primary how-to-section__cta medium-one-third-width-cell"
                >
                  {R.path(['Carousel4', 'cta', 'title'], carousels)}
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    />

    <OptionalSection
      renderCondition={R.has('Carousel5', carousels)}
      section={() => (
        <div className="how-to-section grid-container">
          <div className="grid-x">
            <div className="cell xsmall-14 xsmall-offset-1 large-12 large-offset-2">
              <Heading level={4} extraClass="how-to-section__heading">
                {R.path(['Carousel5', 'title'], carousels)}
              </Heading>

              <CardsCarousel
                carousel={{
                  carouselsStoreDataKey: 'Carousel5',
                  headingLevel: 4,
                  leftChevronIconSrc: '/ccx-files/assets/chevron-left.svg',
                  rightChevronIconSrc: '/ccx-files/assets/chevron-right.svg',
                  onIndexChange: ({ type, index, isForward }) =>
                    trackCarouselClickEvent({
                      page: 'howTo',
                      carousel: 'Carousel5',
                      type,
                      index,
                      isForward,
                    }),
                }}
                cards={{
                  cardsStoreDataKey: 'Carousel5',
                  headingLevel: 5,
                  isTitleUnderlined: false,
                  cover: true,
                  zoomOnHover: true,
                  hideDescription: true,
                }}
                cardsPerPageMap={{
                  xsmall: 1,
                  small: 2,
                  medium: 3,
                  large: 3,
                  xlarge: 3,
                }}
              />
              {R.path(['Carousel5', 'cta', 'title'], carousels) && (
                <Link
                  title={R.path(['Carousel5', 'cta', 'title'], carousels)}
                  link={R.path(['Carousel5', 'cta', 'href'], carousels)}
                  extraClass="button button--large button--primary how-to-section__cta medium-one-third-width-cell"
                >
                  {R.path(['Carousel5', 'cta', 'title'], carousels)}
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    />
  </StandardLayout>
);

HowToComponent.propTypes = {
  carousels: PropTypes.objectOf(PropTypes.object),
};

export default connect(({ content }) => ({
  carousels: R.prop('carousels', content),
}))(HowToComponent);
